import { AppSettingsService } from "@/services/appSettings";
import { useQuery } from "@tanstack/react-query";

export const APP_SETTINGS_QUERY_KEY = ["appSettings"];

export const useAppSettingsQuery = () =>
  useQuery({
    queryKey: APP_SETTINGS_QUERY_KEY,
    queryFn: () => AppSettingsService.getSettings(),
    refetchOnWindowFocus: false,
  });
